<template>
    <rkm-overlay>
        <rkm-layout-body title="Lista de destino">
            <template v-slot:actions>
                <rkm-button
                    @click="$router.push({ name: 'transporte-paciente-destino-create' })"
                    autorize="store-transporte-paciente-destino"
                    color="primary"
                >
                    Cadastrar destino
                </rkm-button>
            </template>

            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>

// Components.
import List from '@/components/transporte-paciente/destino/List'

export default {
    components: { List },
}
</script>